module.exports = __webpack_public_path__ + "img/redReport.5d3caf5a.png";